export default {
  /*
   * カンマ除去
   */
  removeComma: function (num) {
    if (!num) { return null }

    if (window.isFinite(num) === true) {
      return parseInt(num, 10)
    }
    var removedNum = num.replace(/,/g, '')
    return parseInt(removedNum, 10)
  }
}
